module.exports = __webpack_public_path__ + "img/39.b51bf2a.jpg";